// Translations
import error from 'pages/error/translations/en'
import login from 'pages/login/translations/en'
import passwordChange from 'pages/password-change/translations/en'
import register from 'pages/register/translations/en'
import reset from 'pages/reset/translations/en'
import termsOfService from 'pages/terms-of-service/translations/en'
import twoFactorAuthentication from 'pages/two-factor-authentication/translations/en'
import verification from 'pages/verification/translations/en'

// Translation: English > Pages
const pages = Object.freeze({
	error,
	login,
	passwordChange,
	register,
	reset,
	termsOfService,
	twoFactorAuthentication,
	verification
})

// Export
export default pages
